module.exports = __webpack_public_path__ + "img/icon_noclaim.18d39953.png";